import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { BaseQueryParams } from 'types/base-query-params';
import { PaginatedResponse } from 'types/dtos';
import { ResponseWebsiteDto } from '../types/dtos';
import { constructQueryParams } from 'utils/query-params-builder';
import { APP_ENDPOINTS } from 'app/endpoints';

export type WebsitesQueryParams = BaseQueryParams & {
    companyId?: string;
};

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.query<PaginatedResponse<ResponseWebsiteDto>, WebsitesQueryParams>({
        async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
            const websitesResponse = await fetchWithBQ(constructQueryParams(APP_ENDPOINTS.WEBSITES, _arg));

            if (websitesResponse.error) {
                return { error: websitesResponse.error };
            }

            const websites = websitesResponse.data as PaginatedResponse<ResponseWebsiteDto>;

            return {
                data: websites,
            };
        },
        providesTags: [{ type: 'websites', id: 'GET' }],
    });
